/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_PURCHASE_INVOICE_REPORT_SUCCESS,
  LOAD_PURCHASE_INVOICE_REPORT_ERROR,
  LOAD_PURCHASE_INVOICE_BARCODE_SUCCESS,
  LOAD_PURCHASE_INVOICE_BARCODE_ERROR,
  LOAD_LEDGER_STATEMENT_REPORT_SUCCESS,
  LOAD_LEDGER_STATEMENT_REPORT_ERROR,
  LOAD_PARTY_WISE_OUTSTANDING_REPORT_SUCCESS,
  LOAD_PARTY_WISE_OUTSTANDING_REPORT_ERROR,
  LOAD_RECORDS_VALID_CACHE,
  LOAD_REPORTS_META_DATA_SUCCESS,
  LOAD_REPORTS_META_DATA_ERROR,
  LOAD_BILL_STATUS_META_DATA_SUCCESS,
  LOAD_BILL_STATUS_META_DATA_ERROR,
  CREATE_PURCHASE_INVOICE_SUCCESS,
  CREATE_PURCHASE_INVOICE_ERROR,
  UPDATE_PURCHASE_INVOICE_SUCCESS,
  UPDATE_PURCHASE_INVOICE_ERROR,
  DELETE_PURCHASE_INVOICE_SUCCESS,
  DELETE_PURCHASE_INVOICE_ERROR,
  LOAD_PURCHASE_INVOICE_CATEGORY_SUCCESS,
  LOAD_PURCHASE_INVOICE_CATEGORY_ERROR,
  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_SUCCESS,
  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_ERROR,
  LOAD_PARTIES_TRANSACTION_SUCCESS,
  LOAD_PARTIES_TRANSACTION_ERROR,
  LOAD_PARTY_VENDOR_ADDRESS_SUCCESS,
  LOAD_PARTY_VENDOR_ADDRESS_ERROR,
  CREATE_PARTY_VENDOR_ADDRESS_SUCCESS,
  CREATE_PARTY_VENDOR_ADDRESS_ERROR,
  LOAD_REPORTS_DASHBOARD_TRANSACTION_SUCCESS,
  LOAD_REPORTS_DASHBOARD_TRANSACTION_ERROR,
  LOAD_PURCHASE_REPORT_TOTAL_SUCCESS,
  LOAD_PURCHASE_REPORT_TOTAL_ERROR,
  LOAD_TOTAL_REPORT_PAID_SUCCESS,
  LOAD_TOTAL_REPORT_PAID_ERROR,
  LOAD_TOTAL_REPORT_UNPAID_SUCCESS,
  LOAD_TOTAL_REPORT_UNPAID_ERROR,
  //reports
  LOAD_STOCK_REPORT_DETAILS_SUCCESS,
  LOAD_STOCK_REPORT_DETAILS_ERROR,
  LOAD_BARCODE_DETAILS_REPORT_SUCCESS,
  LOAD_BARCODE_DETAILS_REPORT_ERROR,
  LOAD_ITEMS_QUANTITY_REPORT_SUCCESS,
  LOAD_ITEMS_QUANTITY_REPORT_ERROR,
  LOAD_SALES_ITEMS_QUANTITY_REPORT_SUCCESS,
  LOAD_SALES_ITEMS_QUANTITY_REPORT_ERROR,
  LOAD_SALES_FILTER_REPORT_SUCCESS,
  LOAD_SALES_FILTER_REPORT_ERROR,
  LOAD_SALES_SUMMARY_REPORT_SUCCESS,
  LOAD_SALES_SUMMARY_REPORT_ERROR,
  LOAD_PURCHASE_SUMMARY_REPORT_SUCCESS,
  LOAD_PURCHASE_SUMMARY_REPORT_ERROR,
  LOAD_SALES_RETURN_REPORT_SUCCESS,
  LOAD_SALES_RETURN_REPORT_ERROR,
  LOAD_SALES_RETURN_ITEMS_REPORT_SUCCESS,
  LOAD_SALES_RETURN_ITEMS_REPORT_ERROR,
  LOAD_PROFIT_REPORT_LIST_SUCCESS,
  LOAD_PROFIT_REPORT_LIST_ERROR,
} from "./constants";

const initialState = {
  purchase_invoice_list: [],
  purchase_barcode_list: [],
  barcode_report_list: {},
  profit_report_list: {},
  party_ledger_statement: [],
  party_wise_outstanding: [],
  dashboard_transactions: [],
  purchase_total_list: [],
  total_paid_list: [],
  total_unpaid_list: [],
  parties_collect_list: [],
  parties_pay_list: [],
  category_list: [],
  party_address_list: [],
  parties_transaction_list: [],
  stock_report_list: {},
  item_quantity_report: {},
  sales_item_quantity_report: {},
  sales_filter_report: {},
  sales_summary_report: {},
  purchase_summary_report: {},
  sales_return_report: {},
  sales_return_items_report: {},
  record: {},
  records: {},
  recordsMetaData: {},
  billStatusMetaData: {},
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  {
    type,
    purchase_invoice_list,
    purchase_barcode_list,
    party_ledger_statement,
    barcode_report_list,
    profit_report_list,
    dashboard_transactions,
    purchase_total_list,
    total_paid_list,
    total_unpaid_list,
    party_address_list,
    category_list,
    parties_transaction_list,
    stock_report_list,
    item_quantity_report,
    sales_item_quantity_report,
    sales_filter_report,
    sales_summary_report,
    party_wise_outstanding,
    purchase_summary_report,
    sales_return_report,
    sales_return_items_report,
    record,
    recordsMetaData = {},
    billStatusMetaData = {},
    error,
    success,
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PURCHASE_INVOICE_REPORT_SUCCESS:
        draft.purchase_invoice_list = purchase_invoice_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_LEDGER_STATEMENT_REPORT_SUCCESS:
        draft.party_ledger_statement = party_ledger_statement;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PARTY_WISE_OUTSTANDING_REPORT_SUCCESS:
        draft.party_wise_outstanding = party_wise_outstanding;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PURCHASE_INVOICE_BARCODE_SUCCESS:
        draft.purchase_barcode_list = purchase_barcode_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_REPORTS_DASHBOARD_TRANSACTION_SUCCESS:
        draft.dashboard_transactions = dashboard_transactions;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PURCHASE_REPORT_TOTAL_SUCCESS:
        draft.purchase_total_list = purchase_total_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_TOTAL_REPORT_PAID_SUCCESS:
        draft.total_paid_list = total_paid_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_TOTAL_REPORT_UNPAID_SUCCESS:
        draft.total_unpaid_list = total_unpaid_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PARTY_VENDOR_ADDRESS_SUCCESS:
        draft.party_address_list = party_address_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PURCHASE_INVOICE_CATEGORY_SUCCESS:
        draft.category_list = category_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_STOCK_REPORT_DETAILS_SUCCESS:
        draft.stock_report_list = stock_report_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_ITEMS_QUANTITY_REPORT_SUCCESS:
        draft.item_quantity_report = item_quantity_report;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_SALES_ITEMS_QUANTITY_REPORT_SUCCESS:
        draft.sales_item_quantity_report = sales_item_quantity_report;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_SALES_FILTER_REPORT_SUCCESS:
        draft.sales_filter_report = sales_filter_report;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_SALES_SUMMARY_REPORT_SUCCESS:
        draft.sales_summary_report = sales_summary_report;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PURCHASE_SUMMARY_REPORT_SUCCESS:
        draft.purchase_summary_report = purchase_summary_report;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_SALES_RETURN_REPORT_SUCCESS:
        draft.sales_return_report = sales_return_report;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_SALES_RETURN_ITEMS_REPORT_SUCCESS:
        draft.sales_return_items_report = sales_return_items_report;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_BARCODE_DETAILS_REPORT_SUCCESS:
        draft.barcode_report_list = barcode_report_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PROFIT_REPORT_LIST_SUCCESS:
        draft.profit_report_list = profit_report_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case LOAD_PARTIES_TRANSACTION_SUCCESS:
        draft.parties_transaction_list = parties_transaction_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_PURCHASE_INVOICE_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case CREATE_PARTY_VENDOR_ADDRESS_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case UPDATE_PURCHASE_INVOICE_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.error = false;
        draft.success = success;
        break;
      case DELETE_PURCHASE_INVOICE_SUCCESS:
        draft.record = record;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_REPORTS_META_DATA_SUCCESS:
        draft.recordsMetaData = recordsMetaData;
        draft.error = false;
        draft.success = success;
        break;
      case LOAD_BILL_STATUS_META_DATA_SUCCESS:
        draft.billStatusMetaData = billStatusMetaData;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_PURCHASE_INVOICE_REPORT_ERROR:
      case LOAD_PARTY_WISE_OUTSTANDING_REPORT_ERROR:
      case LOAD_PURCHASE_INVOICE_BARCODE_ERROR:
      case LOAD_PURCHASE_INVOICE_CATEGORY_ERROR:
      case LOAD_PARTY_VENDOR_ADDRESS_ERROR:
      case LOAD_BARCODE_DETAILS_REPORT_ERROR:
      case CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_ERROR:
      case CREATE_PARTY_VENDOR_ADDRESS_ERROR:
      case LOAD_PARTIES_TRANSACTION_ERROR:
      case LOAD_REPORTS_DASHBOARD_TRANSACTION_ERROR:
      case LOAD_PURCHASE_REPORT_TOTAL_ERROR:
      case LOAD_STOCK_REPORT_DETAILS_ERROR:
      case LOAD_ITEMS_QUANTITY_REPORT_ERROR:
      case LOAD_TOTAL_REPORT_UNPAID_ERROR:
      case LOAD_TOTAL_REPORT_PAID_ERROR:
      case CREATE_PURCHASE_INVOICE_ERROR:
      case UPDATE_PURCHASE_INVOICE_ERROR:
      case DELETE_PURCHASE_INVOICE_ERROR:
      case LOAD_LEDGER_STATEMENT_REPORT_ERROR:
      case LOAD_SALES_ITEMS_QUANTITY_REPORT_ERROR:
      case LOAD_SALES_FILTER_REPORT_ERROR:
      case LOAD_SALES_SUMMARY_REPORT_ERROR:
      case LOAD_PURCHASE_SUMMARY_REPORT_ERROR:
      case LOAD_BILL_STATUS_META_DATA_ERROR:
      case LOAD_SALES_RETURN_REPORT_ERROR:
      case LOAD_SALES_RETURN_ITEMS_REPORT_ERROR:
      case LOAD_PROFIT_REPORT_LIST_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.success = false;
        break;

      case LOAD_REPORTS_META_DATA_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
